import { localStorage } from './storage';

const RECENT_SEARCHES_KEY = 'recent_searches';
const MAX_RECENT_SEARCHES = 5;
const MIN_SEARCH_LENGTH = 2;

export interface iRecentSearch {
  term: string;
  timestamp: number;
}

/**
 * Get the list of recent searches
 */
export const getRecentSearches = (): iRecentSearch[] => {
  const searches = localStorage.get<iRecentSearch[]>(RECENT_SEARCHES_KEY, []);
  return Array.isArray(searches) ? searches : [];
};

/**
 * Add a search term to the recent searches list
 * @param term - The search term to add
 */
export const addRecentSearch = (term: string): void => {
  if (!term || term.trim().length < MIN_SEARCH_LENGTH) return;

  const trimmedTerm = term.trim();
  let searches = getRecentSearches();

  // Remove if term already exists (to move it to top)
  searches = searches.filter(s => s.term !== trimmedTerm);

  // Add new search at the beginning
  searches.unshift({
    term: trimmedTerm,
    timestamp: Date.now()
  });

  // Keep only last 5
  searches = searches.slice(0, MAX_RECENT_SEARCHES);

  localStorage.set(RECENT_SEARCHES_KEY, searches);
};

/**
 * Clear all recent searches
 */
export const clearRecentSearches = (): void => {
  localStorage.forget(RECENT_SEARCHES_KEY);
};

/**
 * Remove a specific search term
 * @param term - The search term to remove
 */
export const removeRecentSearch = (term: string): void => {
  let searches = getRecentSearches();
  searches = searches.filter(s => s.term !== term);
  localStorage.set(RECENT_SEARCHES_KEY, searches);
};
